module.exports = __webpack_public_path__ + "static/F4_image_01-962a82e0742e9059980d03fd64e9414d.png";